/**
 * 基本路由
 */
// export const BASE_ROUTE = '/urge'; // 测试环境
export var BASE_ROUTE = ''; // 本地、生产环境
